<template>
  <div class="pt-md-4 pt-3 pb-5">
    <div class="audio-wrapper" id="player-container">
      <audio id="player" @timeupdate="initProgressBar" ref="audioPlayer" @progress="progressLoad">
        <source :src="audioData.audio_url">
      </audio>
    </div>
    <div class="rounded-top border border-bottom-0
      d-flex align-items-center justify-content-between p-3">
      <div class="d-md-inline-block d-none">
        <p class="font-weight-bold mb-0">
          {{ audioStatus.currentTimeDisplay }} /
          <span class="text-muted">{{ audioStatus.totalLength }}</span>
        </p>
      </div>
      <div class="d-flex align-items-center w-md-auto w-100">
        <a href="" class="text-secondary mr-3 order-2 order-md-1 ml-md-3 ml-auto"
          @click.prevent="fifteenSecond('back')">
          <img :src="'/img/frontend/course/ic-replay.svg'" alt="" class="ic-forward-replay">
        </a>
        <a href="" class="loading_circle bg-primary rounded-circle
          d-flex align-items-center justify-content-center
          order-1 order-md-2 text-decoration-none" @click.prevent="togglePlay">
          <div v-if="isLoading" class="spinner-border my-2 text-white" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <span v-else class="material-icons
            d-inline-block align-bottom pause_circle text-white">
            {{ audioStatus.isPlaying? 'pause':'play_arrow' }}
          </span>
        </a>
        <div class="btn-group dropleft position-relative d-md-none d-inline-block order-3">
          <a href="" class="mb-0 text-secondary" data-toggle="dropdown">
             {{ audioStatus.playbackRate }}x
          </a>
          <div class="dropdown-menu py-0 border-0 position-absolute bg-white">
            <a :class="{'active': n == audioStatus.playbackRate}"
              @click.prevent="speedUp(n)" href=""
              v-for="(n, index) in playbackRateValue"
              class="list-group-item list-group-item-action" :key="n + index">
              {{ n }} x
            </a>
          </div>
        </div>
        <a href="" class="text-secondary mx-3 order-3 order-md-3"
          @click.prevent="fifteenSecond('forward')">
          <img :src="'/img/frontend/course/ic-forward.svg'" alt="" class="ic-forward-replay">
        </a>
      </div>
      <div class="flex-wrap align-items-center d-md-flex d-none">
        <div class="btn-group dropleft position-relative">
          <a href="" class="mb-0 text-secondary" data-toggle="dropdown">
             {{ audioStatus.playbackRate }}x
          </a>
          <div class="dropdown-menu py-0 border-0 position-absolute bg-white">
            <a :class="{'active': n == audioStatus.playbackRate}"
              @click.prevent="speedUp(n)" href=""
              v-for="(n, index) in playbackRateValue"
              class="list-group-item list-group-item-action" :key="n + index">
              {{ n }} x
            </a>
          </div>
        </div>
        <div class="align-items-center h4 text-secondary mb-0 player-controls d-md-flex d-none">
          <span class="material-icons mx-3">
            volume_up
          </span>
          <input type="range" class="custom-range-volume" v-model="audioStatus.volumeValue"
            step="0.1" max="1" @change="volumeChange($event)"
            :style="{ background: volumeValueBg}"
            style="min-width: 80px;">
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between
      px-2 pb-md-0 pb-2 border-left border-right d-md-none">
      <small>{{ audioStatus.currentTimeDisplay }}</small>
      <small>{{ audioStatus.totalLength }}</small>
    </div>
    <div class="position-relative d-flex">
      <div v-if="audioStatus.totalLength == 0" class="progress-background"></div>
      <input type="range" class="custom-range-progress w-100 rounded-bottom position-relative"
        :class="{'d-none': audioStatus.totalLength == 0}" v-model="audioStatus.progressValue"
        step="0.001" max="1" @change="progressClickCurrentTime($event)" @input="onInput"
        :style="{'--left': audioStatus.progressValue*100 + '%', background: progressValueBg,
        '--time': progressOnInput? JSON.stringify(calculateCurrentValue(tempProgressValue)) : '' }">
    </div>
  </div>
</template>

<script>
export default {
  name: 'AudioPlyer',
  props: ['audioData', 'scroll'],
  data() {
    return {
      playbackRateValue: [0.75, 1, 1.25, 1.5, 1.75, 2],
      audioStatus: {
        length: 0,
        currentTime: 0,
        totalLength: 0,
        currentTimeDisplay: 0,
        isPlaying: false,
        progressValue: 0,
        volumeValue: 1,
        playbackRate: 0,
      },
      volumeValueBg: 'linear-gradient(90deg, #3D5AFE 100%,#E8EAF6 0%)',
      progressValueBg: 'linear-gradient(90deg, #3D5AFE 0%,#E8EAF6 0%)',
      tempProgressValue: 0,
      setSecond: 0,
      firstPlay: false,
      isLoading: false,
      fullPage: false,
      progressOnInput: false,
      debouncedGetAnswer() {},
    };
  },
  methods: {
    progressLoad() {
      const vm = this;
      vm.isLoading = true;
      const { userAgent } = navigator;
      const isiOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) {
        for (let i = 0; i < document.getElementById('player').buffered.length; i++) {
          if (document.getElementById('player').buffered.end(i) == document.getElementById('player').duration) {
            vm.isLoading = false;
            this.debouncedGetAnswer = _.debounce(this.recordCurrentInLocalStorage, 1000);
            const localData = JSON.parse(window.localStorage.getItem('biz_thinking_audio')) || [];
            if (localData.length > 0) {
              const second = localData.filter((data) => data.id == vm.audioData.id);
              if (second.length > 0) {
                vm.setSecond = second[0].current_time;
                document.getElementById('player').currentTime = vm.setSecond;
              }
            }
          }
        }
      } else {
        vm.isLoading = false;
        this.debouncedGetAnswer = _.debounce(this.recordCurrentInLocalStorage, 1000);
      }
    },
    initProgressBar() { // 持續更新 audio 狀態
      const vm = this;
      if (document.getElementById('player')) {
        vm.audioStatus.length = document.getElementById('player').duration;
        vm.audioStatus.currentTime = document.getElementById('player').currentTime;
        vm.audioStatus.totalLength = vm.calculateCurrentValue(document.getElementById('player').duration);
        vm.audioStatus.currentTimeDisplay = vm.calculateCurrentValue(vm.audioStatus.currentTime);
        if (!vm.progressOnInput) {
          vm.audioStatus.progressValue = document.getElementById('player').currentTime / document.getElementById('player').duration;
        }
        vm.audioStatus.playbackRate = document.getElementById('player').playbackRate;
        if (document.getElementById('player').currentTime == document.getElementById('player').duration) {
          vm.gaTrackEvent('Audio', 'Complete', vm.audioData.name);
          vm.audioStatus.isPlaying = false;
        }
      }
    },
    togglePlay() { // 播放切換
      const vm = this;
      if (!vm.isLoading) {
        if (document.getElementById('player').paused === false) {
          document.getElementById('player').pause();
          vm.gaTrackEvent('Audio', 'Pause', vm.audioData.name);
          vm.audioStatus.isPlaying = false;
        } else {
          document.getElementById('player').play();
          vm.gaTrackEvent('Audio', 'Play', vm.audioData.name, vm.audioStatus.currentTime);
          vm.audioStatus.isPlaying = true;
        }
      }
    },
    speedUp(playbackRate) {
      const vm = this;
      document.getElementById('player').playbackRate = playbackRate;
      vm.gaTrackEvent('Audio', 'Adjust Speed', vm.audioData.name, playbackRate);
    },
    volumeChange(evt) { // 音量
      const vm = this;
      document.getElementById('player').volume = evt.target.value;
      vm.audioStatus.volumeValue = evt.target.value;
    },
    fifteenSecond(type) { // 往前/往後 15 秒
      const vm = this;
      const changeSecond = type == 'forward' ? document.getElementById('player').currentTime + 15 : document.getElementById('player').currentTime - 15;
      document.getElementById('player').currentTime = changeSecond > 0 ? changeSecond : 0;
      // ga
      if (type == 'forward') {
        vm.gaTrackEvent('Audio', 'Fast Forward 15', vm.audioData.name);
      } else if (type == 'back') {
        vm.gaTrackEvent('Audio', 'Rewind 15', vm.audioData.name);
      }
    },
    progressClickCurrentTime(evt) { // 點擊換秒數
      const vm = this;
      vm.progressOnInput = false;
      // const audio_player = vm.$refs.audioPlayer;
      const percent = evt.offsetX / evt.target.offsetWidth;
      document.getElementById('player').currentTime = evt.target.value * document.getElementById('player').duration;
      vm.audioStatus.progressValue = percent / 100;
    },
    onInput(evt) { // 當使用者拉住 progress 的時候
      const vm = this;
      vm.progressOnInput = true;
      vm.tempProgressValue = evt.target.value * document.getElementById('player').duration;
    },
    calculateCurrentValue(currentTime) { // 時間顯示轉換c
      if (!Number.isNaN(currentTime)) {
        const currentMinute = parseInt(currentTime / 60, 10) % 60;
        const currentSecondsLong = currentTime % 60;
        const currentSeconds = Math.floor(currentSecondsLong);
        const currentTimeParse = `${currentMinute < 10 ? `0${currentMinute}` : currentMinute}:${currentSeconds < 10 ? `0${currentSeconds}` : currentSeconds}`;
        return currentTimeParse;
      }
      return '00:00';
    },
    recordCurrentInLocalStorage() {
      const vm = this;
      const audio_player = vm.$refs.audioPlayer;
      if (audio_player) {
        const nowData = {
          id: vm.audioData.id,
          current_time: audio_player.currentTime,
        };
        const localData = JSON.parse(window.localStorage.getItem('biz_thinking_audio')) || [];
        const dataIndex = localData.findIndex((element) => element.id == vm.audioData.id);
        if (dataIndex > -1) {
          localData[dataIndex] = nowData;
        } else {
          localData.push(nowData);
        }
        window.localStorage.setItem('biz_thinking_audio', JSON.stringify(localData));
      }
    },
    audioOnCanplay() { // 用在行動裝置預先加載
      if (window.innerWidth < 768) {
        document.getElementById('player').muted = true;
        document.getElementById('player').play();
        setTimeout(() => {
          document.getElementById('player').pause();
          document.getElementById('player').muted = false;
        }, 100);
      }
    },
  },
  watch: {
    'audioStatus.currentTimeDisplay': function () {
      this.debouncedGetAnswer();
    },
    'audioStatus.volumeValue': function () {
      this.volumeValueBg = `linear-gradient(90deg, #3D5AFE ${this.audioStatus.volumeValue * 100}%, #E8EAF6 0%)`;
    },
    'audioStatus.progressValue': function () {
      this.progressValueBg = `linear-gradient(90deg, #3D5AFE ${this.audioStatus.progressValue * 100}%, #E8EAF6 0%)`;
    },
  },
  mounted() {
    const vm = this;
    document.getElementById('player').onloadedmetadata = function () {
      const localData = JSON.parse(window.localStorage.getItem('biz_thinking_audio')) || [];
      if (localData.length > 0) {
        const second = localData.filter((data) => data.id == vm.audioData.id);
        if (second.length > 0) {
          vm.setSecond = second[0].current_time;
          document.getElementById('player').currentTime = vm.setSecond;
        }
      }
      vm.initProgressBar();
      vm.audioOnCanplay();
    };
    document.getElementById('player').load();
  },
  created() {
  },
};
</script>

<style scoped>
.custom-range-progress::after {
  content: var(--time);
  font-size: 12px;
  position: absolute;
  top: 100%;
  transform: translate(-50%, 50%);
  left: var(--left);
  opacity: 0.65;
}
.loading_circle {
  width: 48px;
  height: 48px;
}
.pause_circle {
  font-size: 38px;
}
.ic-forward-replay {
  width: 24px;
  height: 24px;
}
@media screen and (max-width: 768px) {
  .loading_circle {
    width: 64px;
    height: 64px;
  }
  .pause_circle {
    font-size: 48px;
  }
  .ic-forward-replay {
    width: 32px;
    height: 32px;
  }
}
</style>
